import React from "react";

const Skeleton: React.FC = () => {
  return (
    <>
      <div className="h-screen w-full touch-none bg-white">
        <main className="px-6 pt-6 ">
          <section className="flex flex-row space-x-2">
            <div className="skeleton-loader h-4 w-4 rounded"></div>
            <div className="skeleton-loader h-4 w-1/2 rounded"></div>
          </section>
          <section className="pt-8">
            <ul className="flex flex-col space-y-6">
              {[1, 2, 3].map((e) => (
                <li className="flex flex-row space-x-4" key={e}>
                  <div className="skeleton-loader h-16 w-16 rounded"></div>
                  <div className="flex grow flex-col space-y-4">
                    <div className="skeleton-loader h-4 w-3/4 rounded"></div>
                    <div className="skeleton-loader h-4 w-1/2 rounded"></div>
                  </div>
                </li>
              ))}
            </ul>
          </section>
        </main>
      </div>
    </>
  );
};

export default Skeleton;
